<template>
  <div id="indexFrame">
    <el-container>
      <el-aside width="170px">
        <div class="menu-top-title">
          <!-- <span>智能锁信息管理系统</span> -->
          <span>一网通管理流动人口控制系统</span>
        </div>
        <div class="left-menu">
          <div
            v-for="item in menuData"
            v-if="item.show"
            :key="item.path"
            class="menu-item-wrapper"
          >
            <div v-if="!item.hasChild" class="menu-no-child">
              <router-link
                class="title menu-item"
                :to="{ name: item.name }"
                tag="div"
                active-class="is-active"
              >
                <i :class="item.clas"></i>{{ item.title }}
              </router-link>
            </div>
            <div
              v-if="item.hasChild"
              class="menu-has-child"
              :class="{
                'no-border-bottom': !menuOpenedObj[item.name],
                'right-border': isCurrentPath(item.name)
              }"
            >
              <div
                class="submenu-title menu-item"
                :class="{ currentPath: isCurrentPath(item.name) }"
                @click="subMenuClicked(item.name)"
              >
                <i :class="item.clas"></i><span>{{ item.title }}</span>
                <!--<i class="el-icon-arrow-down" style="position: absolute;right: 12px;top: 14px;padding: 0 !important;transition: transform .3s;"-->
                <!--:class="{'arrow-down': currentCollapse == item.name && !!openCollapse}"></i>-->
              </div>
              <el-collapse-transition class="submenu-content">
                <div v-show="menuOpenedObj[item.name]">
                  <router-link
                    v-for="(itemChild, index) in item.childMenuData"
                    v-if="itemChild.show"
                    :to="{ name: itemChild.name }"
                    :key="itemChild.path"
                    tag="div"
                    active-class="is-active"
                    class="transition-box  menu-item"
                    :class="{
                      'last-child': item.childMenuData.length == index + 1
                    }"
                  >
                    <span class="point"><div class="middle-dotted">•</div></span
                    >{{ itemChild.childTitle }}
                  </router-link>
                </div>
              </el-collapse-transition>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container>
        <el-header>
          <div class="header-box">
            <div class="left">
              <!--<el-breadcrumb>-->
              <!--<el-breadcrumb-item v-for="item in breadcrumbArr" :to="{ path: item.path }" :key="item.name">{{item.name}}</el-breadcrumb-item>-->
              <!--</el-breadcrumb>-->
            </div>
            <div class="right">
              <span
                class="icon-wrapper"
                title="修改密码"
                style="   display: flex; align-items: center;"
                @click="changePassDialogVisible = true"
              >
                <!-- <i class="iconfont icon-yonghu1 one"></i> -->
                <el-image
                  v-if="role == 1"
                  style="width: 30px; height: 30px;margin-right:5px"
                  :src="imageLogo"
                ></el-image>
                <el-image
                  v-else
                  style="width: 30px; height: 30px;margin-right:5px"
                  :src="imageLogo"
                ></el-image>
                <span class="user-info">{{ companyName }}</span>
              </span>
              <span class="icon-wrapper" @click="logout">
                <i class="iconfont icon-tuichu1 two"></i>
                <span class="log-out">退出</span>
              </span>
            </div>
          </div>
          <el-dialog
            title="修改密码"
            class="change-pass-dialog"
            :visible.sync="changePassDialogVisible"
            @close="changePassDialogClosed"
          >
            <el-form label-width="100px" label-position="left">
              <el-form-item label="用户名">
                <span>{{ companyName }}</span>
              </el-form-item>
              <el-form-item label="输入旧密码">
                <el-input v-model="old_passwd" type="password"></el-input>
              </el-form-item>
              <el-form-item label="输入新密码">
                <el-input v-model="new_passwd" type="password"></el-input>
              </el-form-item>
              <el-form-item label="重复新密码">
                <el-input v-model="new_passwd2" type="password"></el-input>
              </el-form-item>
              <el-form-item label="用户身份">
                <span>{{
                  role == 1 ? "管理员" : role == 2 ? "经销商" : "公安局"
                }}</span>
              </el-form-item>
              <el-form-item label="">
                <el-button @click="changePass" :loading="btnLoading">{{
                  btnLoading ? "正在修改" : "确认修改"
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  data() {
    let role = window.localStorage.getItem("role");
    return {
      imageLogo: require("../../assets/img/logo.png"),
      imageLogo1: require("../../assets/img/4.png"),
      username: "用户名",
      menuOpenedObj: {
        //默认展开的菜单 name
        user: "user",
        house: "house",
        rent: "rent",
        agency: "agency"
      },
      menuData: [
        {
          title: "首页",
          path: "/index",
          name: "index",
          clas: "iconfont icon-shouye2",
          show: role != 3,
          hasChild: false
        },
        {
          title: "首页",
          path: "/policeIndex",
          name: "policeIndex",
          clas: "iconfont icon-shouye2",
          show: role == 3,
          hasChild: false
        },
        {
          title: "房屋管理",
          name: "house",
          clas: "iconfont icon-fangwulouzuoloupanmianxing",
          show: role == 1,
          hasChild: true,
          childMenuData: [
            {
              childTitle: "房屋列表",
              path: "/houseList",
              name: "houseList",
              show: true
            },
            {
              childTitle: "新增房屋信息",
              path: "/houseNew",
              name: "houseNew",
              show: role != 3
            }
          ]
        },
        {
          title: "房屋管理",
          path: "/policeHouseList",
          name: "policeHouseList",
          clas: "iconfont icon-fangwulouzuoloupanmianxing",
          show: role == 3,
          hasChild: false
        },

        {
          title: "房屋分布",
          path: "/houseMap",
          name: "houseMap",
          clas: "el-icon-location-outline",
          show: role == 3,
          hasChild: false
        },

        {
          title: "地区分布",
          path: "/houseMapCap",
          name: "houseMapCap",
          clas: "el-icon-location-outline",
          hasChild: false,
          show: role != 2
        },
        {
          title: "租客管理",
          path: "/tenant",
          name: "tenant",
          clas: "iconfont icon-zukeguanli",
          show: role != 2,
          hasChild: false
        },
        {
          title: "用户管理",
          name: "user",
          clas: "iconfont icon-renyuanzuguanli",
          show: role != 3 && role != 2,
          hasChild: true,
          childMenuData: [
            {
              childTitle: "用户列表",
              path: "/userList",
              name: "userList",
              show: true
            },
            {
              childTitle: "新增用户",
              path: "/newAdd",
              name: "newAdd",
              show: true
            }
          ]
        },
        {
          title: "招租管理",
          name: "rent",
          clas: "iconfont icon-zu",
          show: role != 3 && role != 2,
          hasChild: true,
          childMenuData: [
            {
              childTitle: "招租房屋列表",
              path: "/rentList",
              name: "rentList",
              show: true
            }
            // {childTitle: '新增招租房间', path: '/newAddRent',name: 'newAddRent', show: true},
          ]
        },
        {
          title: "设备列表",
          path: "/device",
          name: "device",
          clas: "iconfont icon-suo",
          show: role != 3,
          hasChild: false
        },

        //新增
        {
          title: "报修",
          name: "agency",
          clas: "iconfont icon-suo",
          show: role == 1,
          hasChild: true,
          childMenuData: [
            {
              childTitle: "报修列表",
              path: "/agencyList",
              name: "agencyList",
              show: true
            }
            // {childTitle: '新增经销商', path: '/newAddAgency',name: 'newAddAgency', show: true},
          ]
        },
        {
          title: "异常预警",
          path: "/abnormaWarning",
          name: "abnormaWarning",
          clas: "iconfont1 icon-yangan",
          show: role != 2,
          hasChild: false
        },
        {
          title: "烟感",
          name: "smoke",
          clas: "iconfont1 icon-yangan",
          show: role != 2,
          hasChild: true,
          childMenuData: [
            {
              childTitle: "烟感列表",
              path: "/smoke",
              name: "smoke",
              show: true
            },
            {
              childTitle: "烟感报警",
              path: "/smokeWarring",
              name: "smokeWarring",
              show: true
            }
          ]
        }
        // 异常预警
      ],
      companyName: "",
      role: "",
      changePassDialogVisible: false,
      old_passwd: "",
      new_passwd: "",
      new_passwd2: "",
      btnLoading: false,
      breadcrumbArr: [
        {
          path: "",
          name: "房屋管理"
        },
        {
          path: "",
          name: "房屋列表"
        }
      ]
    };
  },
  created() {
    this.companyName = window.localStorage.getItem("companyName");
    this.role = window.localStorage.getItem("role");
  },
  methods: {
    async changePass() {
      if (!this.old_passwd) {
        this.$message.error("请输入旧密码");
        return;
      }
      if (!this.new_passwd) {
        this.$message.error("新密码不能为空！");
        return;
      }
      if (this.new_passwd != this.new_passwd2) {
        this.$message.error("两次输入的新密码不一样！");
        return;
      }
      try {
        this.btnLoading = true;
        let res = await this.$http.post("/updatePassword", {
          phone: window.localStorage.getItem("phone"),
          old_passwd: md5(this.old_passwd),
          new_passwd: md5(this.new_passwd)
        });
        if (res.data.result_code == 0) {
          this.$message.success("密码修改成功");
          setTimeout(() => {
            this.changePassDialogVisible = false;
          }, 300);
        } else {
          this.$message.error("密码修改失败");
        }
      } catch (err) {
        this.$message.error(err.toString());
      } finally {
        this.btnLoading = false;
      }
    },
    changePassDialogClosed() {
      this.old_passwd = "";
      this.new_passwd = "";
      this.new_passwd2 = "";
    },
    logout() {
      this.$confirm("确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        window.localStorage.setItem("token", "");
        this.$router.push({ name: "login" });
      });
    },
    subMenuClicked(name) {
      if (!this.menuOpenedObj[name]) {
        this.$set(this.menuOpenedObj, name, name);
      } else {
        this.$delete(this.menuOpenedObj, name);
      }
    },
    isCurrentPath(name) {
      let currentPath = this.$route.path;

      let flag = false;
      this.menuData.forEach(item => {
        if (name == item.name) {
          item.childMenuData.forEach(itemChild => {
            if (itemChild.path == currentPath) {
              flag = true;
            }
          });
        }
      });
      return flag;
    }
  }
};
</script>
<style lang="scss">
#indexFrame {
  min-width: 960px;
  height: 100%;
  .el-container {
    height: 100%;
  }
  .el-aside {
    background-color: #1e2d4d;
    color: #fff;
    .menu-top-title {
      height: 60px;
      // line-height: 60px;
      margin-top: 20px;
      span {
        display: flex;
        background-color: #4d638c;
        padding: 5px 10px;
      }
    }
    .left-menu {
      .menu-item-wrapper {
        /*margin-bottom: 2px;*/
      }
      .menu-item {
        height: 35px;
        line-height: 35px;
        color: #fff;
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC",
          "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        cursor: pointer;
        box-sizing: border-box;
        i {
          width: 24px;
          display: inline-block;
          text-align: center;
          font-size: 14px;
          margin-right: 5px;
        }
      }
      .menu-no-child {
        .title {
          color: #fff;
          margin-left: 15px;
          padding-left: 5px;
          padding-right: 20px;
          /*border-bottom: 1px solid #e0e0e0;*/
          &:hover {
            color: #eee;
            background-color: rgba(77, 99, 140, 0.8);
          }
          &.is-active {
            color: #eee;
            background-color: rgb(77, 99, 140);
          }
        }
      }
      .menu-has-child {
        &.no-border-bottom {
          border-bottom: unset;
        }
        .submenu-title {
          margin-left: 15px;
          padding-left: 5px;
          padding-right: 20px;
          &:hover {
            color: #eee;
            background-color: rgba(77, 99, 140, 0.8);
          }
          &.currentPath {
            color: rgb(160, 178, 210);
          }
        }
        .transition-box {
          margin-left: 28px;
          padding-left: 10px;
          color: #fff;
          &.last-child {
            border-bottom: unset;
          }
          .point {
            color: #fff;
            display: inline-block;
            height: 100%;
            width: 10px;
            padding-right: 5px;
            /*border-left: 1px dotted #333;*/
            vertical-align: top;
            .middle-dotted {
              height: 50%;
              /*border-bottom: 1px dotted #333;*/
            }
          }
          &.is-active {
            color: #fff;
            background-color: rgb(77, 99, 140);
          }
          &:hover {
            background-color: rgba(77, 99, 140, 0.8);
          }
        }
      }
    }
  }
  .el-header {
    height: 60px;
    padding: 0;
    background-color: #fff;
    .header-box {
      width: 100%;
      height: 60px;
      background-color: transparent;
      line-height: 60px;
      color: rgb(40, 54, 84);
      .left {
        display: inline-block;
        width: 200px;
        padding-left: 20px;
        .el-breadcrumb {
          background-color: transparent;
          border-bottom: unset;
          margin-top: 10px;
          .el-breadcrumb__item {
            .el-breadcrumb__inner {
              color: #283654;
            }
          }
        }
      }
      .right {
        margin-right: 50px;
        display: inline-block;
        float: right;
        display: flex;
        .icon-wrapper {
          color: #283654;
          margin-left: 20px;
          cursor: pointer;
          &:hover {
            color: rgba(40, 54, 84, 0.8);
          }
          .user-info {
            font-family: Arial;
            font-weight: 700;
            color: red;
            font-size: 25px;
          }
          i {
            /*font-weight: bold;*/
            vertical-align: middle;
            &.one {
              font-size: 28px;
            }
            &.two {
              font-size: 25px;
            }
          }
          span {
            font-size: 14px;
          }
        }
      }
    }
  }
  .el-main {
    padding: 15px 20px;
    background-color: #fff;
    box-shadow: inset 0 3px 5px #ccc;
    height: 100%;
    color: rgb(40, 54, 84);
  }
  .change-pass-dialog {
    .el-dialog {
      width: 50%;
      min-width: 400px;
      .el-form {
        width: 320px;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/indexFrame.vue